import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import QuestionLibraryOverview from "./QuestionLibraryOverview";
import {
  ACTION_FIELD,
  changeProperty,
  COL_SUBTYPE,
  editQuestionFromLibrary,
  getQuestionLibrary,
  getQuestionLibraryFromOverview,
  PREVIEW_IMAGE_DATA,
  QUESTION_ACTION_FIELD,
  QUESTION_ID,
  QUESTION_ID_VALID,
  QUESTION_LIBRARY,
  QUESTION_NAME,
  QUESTION_RESULT,
  QUESTION_TO_BE_EDITED,
  removeQuestionFromLibrary,
  RESULT,
  SHOW_MODAL_QUESTION_LIBRARY_SETTINGS,
  showModalForSavingQuestionToLibrary,
  showModalForSavingQuestionToMyLibrary,
  showSettingsModalQuestionToLibrary,
  SORT_TABLE_BY,
  SORT_TABLE_ORDER,
  sortColumn,
  SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY
} from "../../../../ducks/questionLibrary";
import { showDialog } from "../../../../ducks/confirmDialog";
import { loadTemplateLanguages, TEMPLATE_LANGUAGES } from "../../../../ducks/surveySettings";
import { loadAllData } from "../../../../ducks/indicatorManagament";
import { LANGUAGE } from "../../../../ducks/languageSelector";
import { LANGUAGE_SELECTOR, QUESTION_LIBRARY_STORE } from "../../../../common/constant";

const mapStateToProps = (state) => {
  const questionLibrary = state[QUESTION_LIBRARY_STORE];
  return {
    questionLibrary: questionLibrary[QUESTION_LIBRARY],
    showModalQuestionLibrarySettings: questionLibrary[SHOW_MODAL_QUESTION_LIBRARY_SETTINGS],
    questionName: questionLibrary[QUESTION_NAME],
    questionId: questionLibrary[QUESTION_ID],
    questionIdValid: questionLibrary[QUESTION_ID_VALID],
    questionActionField: questionLibrary[QUESTION_ACTION_FIELD],
    questionResult: questionLibrary[QUESTION_RESULT],
    previewImageData: questionLibrary[PREVIEW_IMAGE_DATA],
    questionToBeEdited: questionLibrary[QUESTION_TO_BE_EDITED],
    selectedActionField: questionLibrary[ACTION_FIELD],
    selectedResult: questionLibrary[RESULT],
    surveyLanguageForQuestionLibrary: questionLibrary[SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY],
    sortTableBy: questionLibrary[SORT_TABLE_BY],
    sortTableOrder: questionLibrary[SORT_TABLE_ORDER],
    colSubtype: questionLibrary[COL_SUBTYPE],
    templateLanguages: state.surveySettings[TEMPLATE_LANGUAGES],
    locale: state[LANGUAGE_SELECTOR][LANGUAGE]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getQuestionLibrary,
      getQuestionLibraryFromOverview,
      showModalForSavingQuestionToLibrary,
      showModalForSavingQuestionToMyLibrary,
      showSettingsModalQuestionToLibrary,
      changeProperty,
      loadTemplateLanguages,
      editQuestionFromLibrary,
      removeQuestionFromLibrary,
      showDialog,
      sortColumn,
      loadAllData
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionLibraryOverview);
